import { CdaStructuredTextRecord } from 'react-datocms/structured-text';

import BlockItem, { type Block } from '.';

import styles from './GridBlock.module.css';

interface GridBlockRecord extends CdaStructuredTextRecord {
  rows: number;
  columns: number;
  cells: Block[];
}

export default function GridBlock({ cells, columns = 1, rows = 1 }: GridBlockRecord) {
  return (
    <div
      className={styles.container}
      style={{ '--c': columns, '--r': rows } as object}
    >
      {cells.map(BlockItem)}
    </div>
  );
}
